import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowLeftRight, Ban, Coins, CreditCard, Link2, type LucideIcon } from 'lucide-react'
import { BrandMark } from '@clari/ui'
import { EngagementCard } from '@/components/business/EngagementCard'
import { RevenueFigures } from '@/components/business/RevenueFigures'
import { Footer } from '@/components/Footer'

const EARN: { key: string; icon: LucideIcon }[] = [
  { key: 'subscriptions', icon: Coins },
  { key: 'interchange', icon: CreditCard },
  { key: 'fx', icon: ArrowLeftRight },
  { key: 'paylink', icon: Link2 },
]

const REFUSE = [
  'no_interest',
  'no_credit',
  'no_crypto',
  'no_hidden_fees',
  'no_spread',
  'no_partnerships',
]

export function BusinessModel() {
  const { t } = useTranslation('business_model')

  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <div className="mx-auto w-full max-w-4xl flex-1 px-6 py-16">
        <Link to="/">
          <BrandMark />
        </Link>

        <header className="mt-12">
          <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">{t('title')}</h1>
          <p className="mt-4 text-xl text-text-muted">{t('tagline')}</p>
          <p className="mt-2 max-w-2xl text-text-subtle">{t('intro')}</p>
        </header>

        <section className="mt-16">
          <h2 className="text-xl font-medium">{t('earn.title')}</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            {EARN.map(({ key, icon }) => (
              <EngagementCard
                key={key}
                icon={icon}
                label={t(`earn.${key}.label`)}
                desc={t(`earn.${key}.desc`)}
                share={t(`earn.${key}.share`)}
              />
            ))}
          </div>
        </section>

        <section className="mt-16">
          <h2 className="text-xl font-medium">{t('refuse.title')}</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {REFUSE.map((key) => (
              <EngagementCard
                key={key}
                icon={Ban}
                label={t(`refuse.${key}.label`)}
                desc={t(`refuse.${key}.desc`)}
              />
            ))}
          </div>
        </section>

        <RevenueFigures />
      </div>
      <Footer />
    </div>
  )
}
